import { initializeApp } from "@firebase/app";
import React, { useEffect, useState } from "react";
import {
	query,
	onSnapshot,
	collection,
	getFirestore,
	where,
} from "@firebase/firestore";
import { Redirect } from "react-router";
import Loader from "../../generalComponents/Loader";
import Message from "../../generalComponents/Message";
import NavbarBpw from "../../generalComponents/NavbarBpw";
import NavbarBpw2 from "../../generalComponents/NavbarBpw2";
import NavbarBpw3 from "../../generalComponents/NavbarBpw3";
import NavbarBpw4 from "../../generalComponents/NavbarBpw4";
import { PermissionsApp } from "../../humanResources/novelties/permissions/permissionsApp";
import { ChangePassword } from "../usersPaswords/ChangePassword";
import { UsersFunctionsInitial } from "./usersFunctionsInitial";
import { firebaseConfig } from "../../../config/firebaseConfig";
import { AuthorizationsApp } from "../../humanResources/novelties/authorizations/authorizationsApp";
import { UserPersonalData } from "./userPersonalData";
import { NoveltiesApp } from "../../humanResources/novelties/noveltiesApp";
import { RequestsApp } from "../../humanResources/requests/requestsApp";
import { LicencesApp } from "../../humanResources/novelties/licences/licencesApp";

export const UsersFunctionsApp = () => {
	const app = initializeApp(firebaseConfig);
	const db = getFirestore(app);
	const company = localStorage.getItem("usuariosEmpresa");
	const jsonValue = localStorage.getItem("userLocal");
	const localUser = JSON.parse(jsonValue);

	const [dataBase, setDataBase] = useState(null);
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);
	const [permiteViewNovelties, setPermiteViewNovelties] = useState(false);
	const [permiteRequestsMake, setPermiteRequestsMake] = useState(false);
	const [option, setOption] = useState(null);
	const [permisionsPendient, setPermisionsPendient] = useState(null);
	const [licencesPendient, setLicencesPendient] = useState(null);
	const [permisionAmount, setPermisionAmount] = useState(0);
	const [licencesAmount, setLicencesAmount] = useState(0);

	const askPermisions = () => {
		setLoading(true);
		const collectionName = "noveltiesViewPermisions-" + company;

		const q = query(collection(db, collectionName));
		onSnapshot(q, (querySnapshot) => {
			const dataList = [];
			querySnapshot.forEach((doc) => {
				dataList.push(doc.data());
			});
			const email = localUser.email;
			try {
				let noveltiesVewPermisions = dataList.filter(
					(item) => item.typePermision == "NoveltiesView"
				)[0].noveltiesViewPermision;
				if (noveltiesVewPermisions.includes(email)) {
					setPermiteViewNovelties(true);
				} else {
					setPermiteViewNovelties(false);
				}
			} catch (error) {}
			try {
				let requestsMakePermision = dataList.filter(
					(item) => item.typePermision == "RequestsMake"
				)[0].requestsViewPermision;
				if (requestsMakePermision.includes(email)) {
					setPermiteRequestsMake(true);
				} else {
					setPermiteRequestsMake(false);
				}
			} catch (error) {}

			setLoading(false);
		});
	};

	useEffect(() => {
		askEmployee();
		askAutorizerPermisions();
		askAutorizerLicences();
		askPermisions();
	}, []);

	const askEmployee = () => {
		setLoading(true);
		const q = query(
			collection(db, "employees-" + company),
			where("email", "==", localUser.email)
		);
		onSnapshot(
			q,
			(querySnapshot) => {
				let dataList = querySnapshot.docs.map((d) => ({
					...d.data(),
				}));
				setDataBase(dataList[0]);

				setLoading(false);
			},
			(error) => {
				setDataBase(null);
				setError(error);
				setLoading(false);
			}
		);
	};

	const askAutorizerPermisions = () => {
		setLoading(true);
		const nameCollection = "noveltiesEmployees-" + company;
		const q = query(
			collection(db, nameCollection),
			where("noveltyName", "==", "Permiso"),
			where("userAuthorizer", "==", localUser.email),
			where("aprovalStatus", "==", "Pendiente")
		);
		onSnapshot(
			q,
			(querySnapshot) => {
				let dataList = querySnapshot.docs.map((d) => ({
					...d.data(),
				}));

				setPermisionsPendient(dataList);
				setPermisionAmount(dataList.length);
				setLoading(false);
			},
			(error) => {
				setPermisionsPendient(null);
				setError(error);
				setLoading(false);
			}
		);
	};
	const askAutorizerLicences = () => {
		setLoading(true);
		const nameCollection = "noveltiesEmployees-" + company;
		const q = query(
			collection(db, nameCollection),
			where("noveltyName", "==", "Licencia no remunerada"),
			where("userAuthorizer", "==", localUser.email),
			where("aprovalStatus", "==", "Pendiente")
		);
		onSnapshot(
			q,
			(querySnapshot) => {
				let dataList = querySnapshot.docs.map((d) => ({
					...d.data(),
				}));

				setLicencesPendient(dataList);
				setLicencesAmount(dataList.length);
				setLoading(false);
				setLoading(false);
			},
			(error) => {
				setLicencesPendient(null);
				setError(error);
				setLoading(false);
			}
		);
	};

	const changeButton = (option) => {
		setOption(option);
	};

	return (
		<div>
			{localUser.type === "1" ? (
				<NavbarBpw />
			) : localUser.type === "2" ? (
				<NavbarBpw2 />
			) : localUser.type === "3" ? (
				<NavbarBpw3 />
			) : localUser.type === "4" ? (
				<NavbarBpw4 />
			) : (
				<Redirect to="/intruso" />
			)}

			<article>
				{loading ? (
					<Loader />
				) : (
					<div>
						{error && <Message mensaje={error} bgColor="#dc3545" />}

						<div className="containerTime01">
							<div className="containerTime22">
								{dataBase && (
									<div>
										{option === "Datos Personales " ? (
											<button
												className="buttonTime23"
												onClick={() => changeButton("Datos Personales ")}
											>
												Datos Personales
											</button>
										) : (
											<button
												className="buttonTime22"
												onClick={() => changeButton("Datos Personales ")}
											>
												Datos Personales
											</button>
										)}
									</div>
								)}

								{dataBase && dataBase.inmediateBoss && (
									<div>
										{option === "Permisos " ? (
											<button
												className="buttonTime23"
												onClick={() => changeButton("Permisos ")}
											>
												Permisos
											</button>
										) : (
											<button
												className="buttonTime22"
												onClick={() => changeButton("Permisos ")}
											>
												Permisos
											</button>
										)}
									</div>
								)}
								{dataBase && dataBase.inmediateBoss && (
									<div>
										{option === "Licencias " ? (
											<button
												className="buttonTime23"
												onClick={() => changeButton("Licencias ")}
											>
												Licencias
											</button>
										) : (
											<button
												className="buttonTime22"
												onClick={() => changeButton("Licencias ")}
											>
												Licencias
											</button>
										)}
									</div>
								)}

								{dataBase &&
									permisionsPendient &&
									permisionsPendient.length > 0 && (
										<div>
											{option === "Aurorizar " ? (
												<button
													className="buttonTime23R"
													onClick={() => changeButton("Aurorizar ")}
												>
													Aurorizar ( {permisionsPendient.length} )
												</button>
											) : (
												<button
													className="buttonTime22R"
													onClick={() => changeButton("Aurorizar ")}
												>
													Aurorizar ( {permisionsPendient.length} )
												</button>
											)}
										</div>
									)}
								{permisionAmount + licencesAmount > 0 && (
									<div>
										{option === "Aurorizar " ? (
											<button
												className="buttonTime23R"
												onClick={() => changeButton("Aurorizar ")}
											>
												Aurorizar ( {permisionAmount + licencesAmount} )
											</button>
										) : (
											<button
												className="buttonTime22R"
												onClick={() => changeButton("Aurorizar ")}
											>
												Aurorizar ( {permisionAmount + licencesAmount} )
											</button>
										)}
									</div>
								)}

								{permiteViewNovelties && (
									<div>
										{option === "Novedades" ? (
											<button
												className="buttonTime23"
												onClick={() => changeButton("Novedades")}
											>
												Novedades
											</button>
										) : (
											<button
												className="buttonTime22"
												onClick={() => changeButton("Novedades")}
											>
												Novedades
											</button>
										)}
									</div>
								)}

								{dataBase && permiteRequestsMake && (
									<div>
										{option === "Solicitudes " ? (
											<button
												className="buttonTime23"
												onClick={() => changeButton("Solicitudes ")}
											>
												Solicitudes
											</button>
										) : (
											<button
												className="buttonTime22"
												onClick={() => changeButton("Solicitudes ")}
											>
												Solicitudes
											</button>
										)}
									</div>
								)}

								<div>
									{option === "Contraseña" ? (
										<button
											className="buttonTime23"
											onClick={() => changeButton("Contraseña")}
										>
											Contraseña
										</button>
									) : (
										<button
											className="buttonTime22"
											onClick={() => changeButton("Contraseña")}
										>
											Contraseña
										</button>
									)}
								</div>
							</div>

							<div className="containerTime03">
								{option === null && <UsersFunctionsInitial />}
								{option === "Datos Personales " && (
									<UserPersonalData employeeData={dataBase} />
								)}
								{option === "Permisos " && (
									<PermissionsApp employeeData={dataBase} />
								)}
								{option === "Licencias " && (
									<LicencesApp employeeData={dataBase} />
								)}
								{option === "Aurorizar " && (
									<AuthorizationsApp
										permisionsPendient={permisionsPendient}
										licencesPendient={licencesPendient}
									/>
								)}
								{option === "Solicitudes " && (
									<RequestsApp employeeData={dataBase} />
								)}

								{option === "Contraseña" && <ChangePassword />}
								{option === "Novedades" && <NoveltiesApp />}
							</div>
						</div>
					</div>
				)}
			</article>
		</div>
	);
};
